module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkAQAAAABYmaj5AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAd2KE6QAAAAHdElNRQfdCggPCBrTl6FQAAAAR0lEQVQ4y2P4jwQ+MAww7wADDNgPAh4zyFV/BgcP7Cjm/4OBx/8HLjQoeMCEMyh4YEehxtiA8fj//2dgABGDgDeI8vTgKesAwqe27cmAZvkAAAAldEVYdGRhdGU6Y3JlYXRlADIwMTgtMDgtMTNUMTU6MjY6NDIrMDk6MDDfetBBAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDEzLTEwLTA4VDA2OjA4OjI2KzA5OjAwy+cM3gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/tag/36h11/tag36_11_00410_100x100.png
// module id = 3u+f
// module chunks = 0